import React from 'react';
import {
  ServiceAllocation,
} from 'pages/Dashboard/pages/Billing/types';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import isNil from 'lodash/isNil';
import {
  paymentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  HealthCareRemarkCodeDTO,
} from 'dtos/healthCareRemarkCodeDTO';
import {
  isEmptyString,
} from '@populateui/utils';
import EOBCodesPopover, {
  EOBCodesComponentProps,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/EOBCodesPopover';
import RemittanceAdviceRemarkCodeLookup from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/RemittanceAdviceRemarkCodeLookup';

export type HealthRemarkCodeParams = {
  index: number;
  healthCareRemarkCodes: HealthCareRemarkCodeDTO[];
  data: ServiceAllocation;
};

type Props = {
  data: ServiceAllocation;
  index: number;
  readonly?: boolean;
};

const defaultValues: HealthCareRemarkCodeDTO = Object.freeze({
  remarkCode: null,
});

const formKey = 'healthCareRemarkCodes';

function RemarkCodes({ index }: EOBCodesComponentProps) {
  const { control } = useFormContext();

  return (
    <div className="w-full">
      <Controller
        name={`${formKey}.${index}.remarkCode`}
        control={control}
        rules={{
          required: 'Remark Code is required',
          validate: (value) => !isEmptyString(value?.trim()),
        }}
        render={({ field, fieldState: { error } }) => (
          <RemittanceAdviceRemarkCodeLookup
            {...field}
            error={!isNil(error)}
            id="remark-code"
            label={index === 0 ? 'Remark Code' : undefined}
            placeholder="Remark Code"
          />
        )}
      />
    </div>
  );
}

export default function RemarkCodesPopover({
  index,
  data,
  readonly,
}: Props) {
  const { healthCareRemarkCodes } = data;

  return (
    <EOBCodesPopover<HealthCareRemarkCodeDTO>
      data={healthCareRemarkCodes ?? []}
      readonly={readonly}
      formKey={formKey}
      defaultValues={defaultValues}
      CodePopoverComponent={RemarkCodes}
      getLabel={(item) => item?.remarkCode ?? ''}
      tooltip="Add Remittance Advice Remark Code"
      max={2}
      onSubmit={(healthCareRemarkCodes) => {
        paymentsEventChannel.emit('onChangeEOBRemarkCodes', { index, healthCareRemarkCodes, data });
      }}
      popoverProps={{
        classes: {
          paper: '!w-[260px]',
        },
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },

      }}
    />
  );
}
